//****************************************************************************
//
// Copyright(C) 2025, CyberTAN Technology, Inc. All Rights Reserved.
// This source code contains confidential and proprietary
// information of CyberTAN Technology, Inc. Unauthorized reproduction,
// modification, distribution, or disclosure of this file, in whole or in part,
// by any means, is strictly prohibited without prior written permission from
// CyberTAN Technology, Inc.
//
// THIS SOURCE CODE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT.
//
// IN NO EVENT SHALL CYBERTAN TECHNOLOGY, INC. BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOURCE CODE.
//
//****************************************************************************

import { ReactComponent as Exclamation } from 'assets/exclamation-fill.svg';
import { t } from 'i18next';
interface LeaveConfirmType {
  showDialog: boolean;
  cancelNavigation: any;
  confirmNavigation: any;
}

const LeaveConfirm: React.FC<LeaveConfirmType> = ({ showDialog, cancelNavigation, confirmNavigation }) => {
  return (
    <>
      <input checked={showDialog} type="checkbox" id="leaveConfirm" className="modal-toggle" readOnly />
      <div className="modal">
        <div className="modal-box h-max">
          <div className="justify-start items-start gap-4 inline-flex">
            <div className="w-10 h-10 p-2 bg-toast-warning-50 rounded-3xl justify-center items-center flex">
              <Exclamation className="text-toast-warning-400 w-8 h-8 px-0.5 pt-0.5 pb-1 justify-center items-center inline-flex" />
            </div>
            <div className="flex-col justify-start items-start gap-2 inline-flex ">
              <h3 className="text-lg font-semibold leading-7">{t('component.leaveConfirmWarning')}</h3>
              <div className="w-96">
                <span className="py-4 text-sm font-normal leading-tight">{t('component.leaveConfirmYouWantLeave')}</span>
              </div>
            </div>
          </div>
          <div className="modal-action">
            <button type="button" className="btn btn-primary" onClick={cancelNavigation} data-testid="leave-confirm-no-btn">
              {t('modal.btnNo')}
            </button>
            <button type="button" className="btn btn-outline w-auto" onClick={confirmNavigation} data-testid="leave-confirm-yes-btn">
              {t('modal.btnYes')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveConfirm;
